import React, { useContext } from "react";
import "./BuildFreeAditionalEquipment.css";
import { LanguageContext } from "../../context/LanguageContext";

import IconWinter from "../../assets/images/buildFree/ae1.svg";
import IconTrunkMat from "../../assets/images/buildFree/ae2.svg";
import IconRubberMats from "../../assets/images/buildFree/ae3.svg";
import IconTrailer from "../../assets/images/buildFree/ae4.svg";

const EQUIPMENT = [
  { id: 1, name: "Winter wheels", icon: IconWinter },
  { id: 2, name: "Rubber trunk mat", icon: IconTrunkMat },
  { id: 3, name: "Rubber mats front and rear", icon: IconRubberMats },
  { id: 4, name: "Trailer hitch", icon: IconTrailer },
];

const BuildFreeAdditionalEquipment = ({
  selectedEquipment,
  toggleEquipment,
}) => {
  const { texts } = useContext(LanguageContext);
  const t = texts.buildFree || {};
  const equipmentLabels = t.equipment || {};

  return (
    <div className="equipment-wrapper">
      <h2 className="equipment-title">{t.additionalEquipment}</h2>

      <div className="equipment-grid">
        {EQUIPMENT.map((item) => (
          <div
            key={item.id}
            className={`equip-card ${selectedEquipment.includes(item.id) ? "active" : ""}`}
            onClick={() => toggleEquipment(item.id)}
          >
            <img
              src={item.icon}
              className="equip-icon"
              alt={equipmentLabels[item.name] || item.name}
            />
            <p className="equip-name">{equipmentLabels[item.name] || item.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BuildFreeAdditionalEquipment;
